import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';

import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';
import styles from './no-member-results.scss';

export const NoMemberResults = ({ name = '', t }) => {
  return (
    <EmptyStates
      className={styles.container}
      title={t('no-member-results.for-text', { name })}
      content={t('no-member-results.try-again')}
      noBoxClass
    />
  );
};

NoMemberResults.propTypes = {
  name: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default _.flowRight(withTranslate)(NoMemberResults);
